const qs = require('qs'); // json data to form url encoded
import axios from 'axios';
import { modalService } from './ModalService.js';
import i18n from "../language.js";
import { apiDocumenter } from './ApiDocumenter.js';
import { storageService } from '../services/StorageService.js';
var md5 = require('md5');

class Api{
    constructor(){
      //this.api_version="starnet/schoolapp_v5";
      this.api_version="starnet/API/V5/005";
      this.cache={};
      this.post_requests=[];
    }

    getUrl(school,endPoint){
      //alert(school.protocol+school.url+"/"+this.api_version+'/'+endPoint);
      return school.protocol+'www.'+school.url+"/"+this.api_version+'/'+endPoint
    }
    
   
    cacheRequest(school,endPoint,params,result){
      var request=school.url+endPoint;
      for(var key in params){
        request+=key+params[key];
      }
      storageService.setItem(request,result);
      //this.cache[request]=result;
    }
    


    getCachedRequest(school,endPoint,params){
      var request=school.url+endPoint;
      for(var key in params){
        request+=key+params[key];
      }
      
      return storageService.getItem(request);
    }
    

    // return a promise when database is opened
    
    post(school,endPoint,params){
      

      
      // hash is needed to make evcery call unique, the endpoint is not enough
      var hash= md5(JSON.stringify(params));
      var endPointHashed=endPoint+hash;
      // try cancel the previous request
      try{
        //this.post_requests[endPointHashed].cancel();
        //this.post_requests[endPointHashed]=undefined;
        
      }catch(err){
        // nothing
      }
     
      // this is the time to listen for load start
      const CancelToken = axios.CancelToken;
      const source = CancelToken.source();

      /*
      var cache=this.getCachedRequest(school,endPoint,params);
      if(cache){
        return Promise.resolve(cache);
      }
      */
      var promise= new Promise( (resolve,reject) =>{
         
        
          //setTimeout(()=>{
            axios({
              timeout:10000,
              cancelToken: source.token,
              method: 'POST',
              url: school.protocol+"www."+school.url+"/"+this.api_version+'/'+endPoint,
              data: qs.stringify(params),
              headers: { 'content-type': 'application/x-www-form-urlencoded' },
            }).then(result =>{
              //console.log("**************API CALL*************** "+endPoint)
              //console.dir(params)
              // documentate if possible
              apiDocumenter.add(endPoint,params,result);
              
              //this.cacheRequest(school,endPoint,params,result)
              
              // check if result is json
              if(typeof(result.data)!=="object"){
               
                modalService.createAlert(i18n.t('language.no_json')+":"+endPoint+": type="+typeof(result.data)).then(
                  () => {
                    console.log("***JSON ID STRING FROM***")
                    console.log(school.protocol+"www."+school.url+"/"+this.api_version+'/'+endPoint)
                    console.log(qs.stringify(params));
                    console.log("---------------")
                    console.dir(result.data);
                    console.dir(endPoint)
                    console.dir(params)
                    reject();
                  }
                )
                return;
              }
             
              resolve(result);
             
              
              
            }).catch(error=>{
            
              reject(error);
            }).finally(()=>{
              // nothing
            })// axios
          //},250); // timeout
          
        }) // promise
        

        // add method to cancel this promise
        promise.cancel=()=>{
          //source.cancel();
        }

        

        this.post_requests[endPointHashed]=promise;


        return promise;
     
    }
  
}

export let api = new Api();







